module.exports = __webpack_public_path__ + "static/media/Profile-Moderator-04-Firoz-Abdul-Hamid.243a3bbd.png";